/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Type_PhoneInputs */

const en_queue_type_phone = /** @type {(inputs: Queue_Type_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

const de_queue_type_phone = /** @type {(inputs: Queue_Type_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefon`)
};

/**
* | output |
* | --- |
* | "Phone" |
*
* @param {Queue_Type_PhoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const queue_type_phone = /** @type {((inputs?: Queue_Type_PhoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Type_PhoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_queue_type_phone(inputs)
	return de_queue_type_phone(inputs)
});